import React, { Fragment, Suspense, useEffect, useRef, useState } from 'react';
import cx from "classnames";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import CommonHeaderContent from '../../../Common/CommonHeaderContent';
import withUseFormHook from '../../../Common/withUseFormHook';
import { owners_action_list } from '../../Search/Constants';
import CratioLookup from '../../Common/CratioLookup';
import { getSessionValue, populateFormDetails } from '../../../Common/Appcommon';
import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';
import CratioMention from '../../Common/CratioMention';

function TaskAction(props) {
    let { onSelectChange, closeModal, screenDetail, systemActionSubmit, typeofaction, actions, actionIndex, enableActionDelay } = props;
    const [showLoader, setShowLoader] = useState(false);
    const [formData, setFormData] = useState({});
    const [selectedOwner, setOwnerValueSelected] = useState([]);
    const [ownerValue, setOwner] = useState([]);
    let [taskScr, setTaskScreenDetail] = useState([]);
    const [ownerField, setOwnerField] = useState([]);
    const [user, setSelectedUser] = useState(getSessionValue('loginuserid'));
    const buttonClickRef = useRef();
    let formDetail = screenDetail.length > 0 ? screenDetail[0]: [];
    let baseformname = formDetail.length > 0 ? formDetail[1] : "";

    useEffect(() => {


    }, []);

    useEffect(() => {
        (async () => {
            let formDetail = await populateFormDetails("table_52");
            setTaskScreenDetail(formDetail);
            await prepareCreateTaskAction(formDetail);
            if (actions[actionIndex] !== undefined) {
                let actionData = actions[actionIndex];
                await prepareActionEditor(actionData);
            }
        })();

        return () => {
            // this now gets called when the component unmounts
        };

    }, []);

    const prepareActionEditor = async (actionData) => {
        let systemActionStr = actionData.systemActionStr;
        let systemActionData = systemActionStr.split("@");
        let actionFormData = {};
        systemActionData.map((data) => {
            if (data !== "") {
                let actionField = data.split("=");
                if (actionField[0] === "Assigned_To") {
                    owners_action_list.map((item) => {
                        if (item.value === actionField[1]) {
                            setOwnerValueSelected(item);
                        }
                    });
                } else if (actionField[0] === "User") {
                    let userValue = actionField[1];
                    setSelectedUser(userValue);
                } else {
                    actionFormData[actionField[0]] = actionField[1];
                }
            }
        });
        actionFormData['action_id'] = actionData['action_id'];
        setFormData(actionFormData);
    }

    const prepareCreateTaskAction = async (screenDetail) => {
        let fieldDetails = screenDetail.length > 0 ? screenDetail[1] : [];
        let ownerFD = [];
        for (let fi = 0; fi < fieldDetails.length; fi++) {
            let fd = fieldDetails[fi];
            let fieldType = fd[4];
            if (fieldType === "entity_group") {
                ownerFD = fd;
                break;
            }
        }
        setOwnerField(ownerFD);
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        const re = /^[0-9\b]+$/;
        if(value === '' || re.test(value)){
            formData[name] = value;
            setFormData(formData);
        }
    }

    const handleOnChange = (name, value) => {
        formData[name] = value;
        setFormData({...formData});
    }

    const onDropDownChange = async (selectedValue, objName) => {
        if (objName === "owner_option") {
            setOwnerValueSelected(selectedValue);
        }
    }

    const onOwnerChange = async (e, selectedValue, objName) => {
        setOwner(selectedValue);
    }

    const saveTaskAction = async () => {
        let systemActionStr = "task_name=" + formData.action_name + "@";
        systemActionStr += "action_name=" + formData.action_name + "@";
        systemActionStr += "Assigned_To=" + selectedOwner.value + "@";
        systemActionStr += "task_due_on=" + formData.task_due_on + "@";
        if (Object.keys(ownerValue).length > 0) {
            systemActionStr += "User=" + ownerValue.value + "@";
        }
        let createTaskParams = formData;
        createTaskParams['owner'] = ownerValue;
        createTaskParams['selectedOption'] = selectedOwner;
        createTaskParams['systemActionStr'] = systemActionStr;
        createTaskParams["typeofaction"] = typeofaction;
        systemActionSubmit(createTaskParams, actionIndex);
        enableActionDelay();
        closeModal();
    }

    const triggerSubmit = () => {
        buttonClickRef.current.click();
    }
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors } } = useForm();
    let customClassName = errors.action_name ? "is-invalid  d-flex-alone" : " d-flex-alone" + " form-control";

    return <Fragment>
        <CommonHeaderContent
            isModal={true}
            closeModal={closeModal}
            headerTitle={"Add Task"}
            buttonAction={triggerSubmit}
            buttonTxt={"Save & Close"}
            buttonIcon={faFloppyDisk}
            isClassNeeded={false}
            mainContent={
                <Fragment>
                    <form id="action-form" name="task-action">
                        <div className='action-editor-container'>
                            <div className='editor-header'>
                                <span className='headerSpan'>Configure Task</span>
                            </div>
                            <div className='editor-body'>
                                <div className='form-conatiner'>
                                    <div className='input-section create-task-p10 d-grid'>
                                        <label className={'workflow-lbl form-label'} htmlFor="action_name">Task Name (Use # to insert variables.)</label>
                                        {/*<Controller
                                            name="task_name"
                                            control={control}
                                            rules={{ required: formData.task_name === undefined ? "Please provide task name" : "" }}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="task_name"
                                                        id="task-name"
                                                        value={formData.task_name}
                                                        autoComplete={"off"}
                                                        onChange={(e) => {
                                                            onInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.task_name ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.task_name && <em className={`error invalid-feedback`}>{errors.task_name.message}</em>}*/}
                                        <CratioMention
                                            name={"action_name"}
                                            inputID={"action_name"}
                                            value={formData["action_name"]}
                                            fieldkey={"value"}
                                            type={"task"}
                                            message={"Please provide Task Name"}
                                            mentionTrigger={"#"}
                                            handleOnChange={handleOnChange}
                                            formname={baseformname}
                                            control={control}
                                            rows={5}
                                            cols={60}
                                            customClassName={customClassName}
                                        />
                                        {errors.action_name && <em className={`error invalid-feedback`}>{errors.action_name.message}</em>}
                                    </div>
                                    <div className='input-section create-task-p10'>
                                        <label className={'workflow-lbl form-label'} htmlFor="owner_option">Owner</label>
                                        <div className='d-flex-alone'>
                                            <div className={`${(ownerField.length > 0 && Object.keys(selectedOwner).length > 0 && selectedOwner.value === "specific_user") ? 'col-md-6' : 'col-md-12'}`}>
                                                <Controller
                                                    name="owner_option"
                                                    control={control}
                                                    rules={{ required: Object.keys(selectedOwner).length === 0 ? "Choose" : false }}
                                                    render={({ field }) => {
                                                        return (
                                                            <Select
                                                                {...field}
                                                                placeholder={'---Choose One---'}
                                                                menuPlacement={"auto"}
                                                                menuPosition={'fixed'}
                                                                name={"owner_option"}
                                                                id={"owner_option"}
                                                                className={`basic-multi-select ${errors.owner_option ? 'is-invalid' : ''}`}
                                                                classNamePrefix="wa-select"
                                                                value={selectedOwner}
                                                                onChange={e => {
                                                                    onDropDownChange(e, "owner_option");
                                                                    field.onChange(e);
                                                                }}
                                                                options={owners_action_list}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.owner_option && <em className={`error invalid-feedback`}>{errors.owner_option.message}</em>}

                                            </div>
                                            {ownerField.length > 0 && Object.keys(selectedOwner).length > 0 && selectedOwner.value === "specific_user" &&
                                                <div className='col-md-6'>
                                                    <CratioLookup
                                                        customClass={"fc-field dIB Input referenceInput col-md-12"}
                                                        value={user === "" ? ownerValue : user}
                                                        refdetails={ownerField[35]}
                                                        onChangeEvent={onOwnerChange}
                                                        valueProp={"label"}
                                                        attributes={{
                                                            "data-type": "value",
                                                            "data-key": "value_0",
                                                            "data-wgt": "lookup",
                                                        }}
                                                        controls={{ name: "referenceInput" }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='input-section create-task-p10'>
                                        <label className={'workflow-lbl form-label'} htmlFor="task_due_on">Task Due Date</label>
                                        <div className='d-flex-alone align-center'>
                                            <div className='col-md-2'>
                                                <Controller
                                                    name="task_due_on"
                                                    control={control}
                                                    rules={{ required: formData.task_due_on < 0 ? "Please provide task due on" : false}}
                                                    render={({ field }) => {
                                                        return (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                name="task_due_on"
                                                                id="task_due_on"
                                                                defaultValue={"0"}
                                                                value={formData.task_due_on}
                                                                autoComplete={"off"}
                                                                onChange={(e) => {
                                                                    onInputChange(e);
                                                                    field.onChange(e);
                                                                }}
                                                                className={`form-control ${errors.task_due_on ? 'is-invalid' : ''}`}
                                                            />
                                                        );
                                                    }}
                                                />
                                            </div>
                                            <label className={'workflow-lbl ml-1'} >Days from Execution Date                                            </label>
                                        </div>
                                        <div>
                                        Eg. Create a task with due in 2 days from Today (Execution date)
                                        </div>
                                        {errors.task_due_on && <em className={`error invalid-feedback`}>{errors.task_due_on.message}</em>}
                                    </div>

                                </div>
                            </div>
                            <div className='editor-footer modal-footer hide'>
                                <a onClick={(e) => closeModal(e)} class="btn btn-outline-success">Cancel</a>
                                <button ref={buttonClickRef} onClick={handleActionFormSubmit(saveTaskAction)} class="ml-1 btn btn-outline-success">Save</button>
                            </div>
                        </div>
                    </form>
                </Fragment>
            } />
    </Fragment>
}

export default TaskAction;